/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitforapproval3Inputs */

const en_coinvestments_submitforapproval3 = /** @type {(inputs: Coinvestments_Submitforapproval3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit for Approval`)
};

/**
* | output |
* | --- |
* | "Submit for Approval" |
*
* @param {Coinvestments_Submitforapproval3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitforapproval3 = /** @type {((inputs?: Coinvestments_Submitforapproval3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitforapproval3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitforapproval3(inputs)
});
export { coinvestments_submitforapproval3 as "coInvestments_submitForApproval" }